import React from "react";
import { Link } from "react-router";
import { cn } from "../../utils/helpers";
import { useScreenSize } from "../../utils/hooks/useScreenSize ";
import { Button } from "react-bootstrap";
import { Flex } from "antd";

export const BtnAsLink = (props) => {
  const {
    link,
    children,
    resposive = true,
    icon,
    className,
    disabled,
    style,
    ...rest
  } = props;
  const { isMobile, isTablet } = useScreenSize();
  const smallScreen = isMobile || isTablet;

  const btnClassName = cn(
    "btn",
    className,
    resposive && smallScreen && "btn-icon btn-xs",
    disabled && "disabled"
  );
  const spanClassName = cn(resposive && smallScreen ? "d-none" : undefined);

  if (link) {
    return (
      <Link
        to={disabled ? "#" : link}
        className={btnClassName}
        onClick={(e) => {
          if (disabled) {
            e.preventDefault();
            e.stopPropagation();
          }
        }}
        aria-disabled={disabled}
        {...rest}
      >
        {icon}
        {children && <span className={spanClassName}>{children}</span>}
      </Link>
    );
  }

  return (
    <button style={{ textWrap: "nowrap", ...style }} className={btnClassName} disabled={disabled} {...rest}>
      <Flex align="center" gap={8}>
        {icon}
        {children && <span className={spanClassName}>{children}</span>}
      </Flex>
    </button>
  );
};
